<template>
  <div class="object-page-wrapper">
    <div class="page-content">
      <div class="page-content__meta d-flex f-between">
        <h1 class="page-title">Подбор по параметрам</h1>
        <div @click="$router.go(-1)" class="go-back-icon">
          <svg
            class="d-block ml-auto"
            xmlns="http://www.w3.org/2000/svg"
            width="17.999"
            height="18"
            viewBox="0 0 17.999 18"
          >
            <path
              id="Union_9"
              data-name="Union 9"
              d="M-10501-7368.2l-7.2,7.2-1.8-1.8,7.2-7.2-7.2-7.2,1.8-1.8,7.2,7.2,7.2-7.2,1.8,1.8-7.2,7.2,7.2,7.2-1.8,1.8Z"
              transform="translate(10510 7379)"
              fill="#fefefc"
            />
          </svg>
        </div>
      </div>

      <div class="select-form-wrap">
        <div class="select-form-header d-flex">
          <div class="select-range-1">
            <span class="text-white d-block mb-5">Этаж</span>
            <div class="select-range pointer">
              <vue-slider v-model="value" :interval="1">
                <template v-slot:dot>
                  <img :src="require('../../../public/img/range-dot.png')" class="custom-dot" />
                </template>

                <template>
                  <div class="select-range-value d-flex f-between">
                    <div>{{ value[0] }}</div>
                    <div>{{ value[1] }}</div>
                  </div>
                </template>
              </vue-slider>
            </div>
          </div>
          <div class="select-range-2">
            <span class="text-white d-block mb-5">
              Площадь, м
              <sup>2</sup>
            </span>
            <div class="select-range pointer">
              <vue-slider v-model="value" :interval="1">
                <template v-slot:dot>
                  <img :src="require('../../../public/img/range-dot.png')" class="custom-dot" />
                </template>

                <template>
                  <div class="select-range-value d-flex f-between">
                    <div>{{ value[0] }}</div>
                    <div>{{ value[1] }}</div>
                  </div>
                </template>
              </vue-slider>
            </div>
          </div>
          <div class="select-range-3">
            <span class="text-white d-block mb-5">Количество комнат</span>
            <div class="select-range pointer">
              <vue-slider v-model="value" :interval="1">
                <template v-slot:dot>
                  <img :src="require('../../../public/img/range-dot.png')" class="custom-dot" />
                </template>

                <template>
                  <div class="select-range-value d-flex f-between">
                    <div>{{ value[0] }}</div>
                    <div>{{ value[1] }}</div>
                  </div>
                </template>
              </vue-slider>
            </div>
          </div>
          <div class="select-range-4">
            <span class="text-white d-block mb-5">Стоимость, млн сум.</span>
            <div class="select-range pointer">
              <vue-slider v-model="value" :interval="1">
                <template v-slot:dot>
                  <img :src="require('../../../public/img/range-dot.png')" class="custom-dot" />
                </template>

                <template>
                  <div class="select-range-value d-flex f-between">
                    <div>{{ value[0] }}</div>
                    <div>{{ value[1] }}</div>
                  </div>
                </template>
              </vue-slider>
            </div>
          </div>
        </div>
        <div class="select-form-body">
          <div class="form-body-head d-flex align-center text-white mb-5">
            <div
              class="select-form-discount d-flex align-center p-4 pointer"
              @click="toggleDiscount"
            >
              <span>Акция</span>
              <div class="_circle child-center rounded-pill ml-3">
                <div class="_circle-in rounded-pill"></div>
              </div>
            </div>
            <div class="select-form-sort d-flex p-4 pointer p-relative">
              <span>Сортировать по</span>
              <div class="sort-cost-dropdown" @click="show = !show">
                <span class="d-block ml-2 p-relative">Цене</span>
              </div>

              <transition name="fade">
                <div v-if="show" class="sort-dropdown p-absolute rounded-sm">
                  <div class="d-flex p-3">
                    <svg
                      class="mr-2"
                      aria-hidden="true"
                      focusable="false"
                      data-prefix="fal"
                      data-icon="long-arrow-up"
                      role="img"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 256 512"
                    >
                      <path
                        fill="currentColor"
                        d="M3.515 168.97l7.07 7.071c4.686 4.686 12.284 4.686 16.971 0L111 92.113V468c0 6.627 5.373 12 12 12h10c6.627 0 12-5.373 12-12V92.113l83.444 83.928c4.686 4.686 12.284 4.686 16.971 0l7.07-7.071c4.686-4.686 4.686-12.284 0-16.97l-116-116.485c-4.686-4.686-12.284-4.686-16.971 0L3.515 152c-4.687 4.686-4.687 12.284 0 16.97z"
                        class
                      />
                    </svg>
                    По возрастанию
                  </div>

                  <div class="d-flex p-3">
                    <svg
                      class="mr-2"
                      aria-hidden="true"
                      focusable="false"
                      data-prefix="fal"
                      data-icon="long-arrow-down"
                      role="img"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 256 512"
                    >
                      <path
                        fill="currentColor"
                        d="M252.485 343.03l-7.07-7.071c-4.686-4.686-12.284-4.686-16.971 0L145 419.887V44c0-6.627-5.373-12-12-12h-10c-6.627 0-12 5.373-12 12v375.887l-83.444-83.928c-4.686-4.686-12.284-4.686-16.971 0l-7.07 7.071c-4.686 4.686-4.686 12.284 0 16.97l116 116.485c4.686 4.686 12.284 4.686 16.971 0l116-116.485c4.686-4.686 4.686-12.284-.001-16.97z"
                        class
                      />
                    </svg>
                    По убыванию
                  </div>
                </div>
              </transition>
            </div>
          </div>

          <div class="select-form-table">
            <div class="form-table-items d-flex align-center text-white">
              <div class="f-full">
                <p class="color-primary">2-01</p>
              </div>
              <div class="f-full">
                <span>
                  12,00 м
                  <sup>2</sup>
                </span>
              </div>
              <div class="f-full">
                <span>1 комната</span>
              </div>
              <div class="f-full">
                <span>2 этаж</span>
              </div>
              <div class="f-full">
                <span class="color-primary">Акция</span>
              </div>
              <div class="f-full">
                <span>
                  15 000 000 сум / м
                  <sup>2</sup>
                </span>
              </div>
              <div class="f-full">
                <div class="text-right">
                  <span class="line-through d-block color-primary mb-1">46 000 000 сум</span>
                  <span>46 000 000 сум</span>
                </div>
              </div>
            </div>

            <div class="form-table-items d-flex align-center text-white">
              <div class="f-full">
                <p class="color-primary">2-01</p>
              </div>
              <div class="f-full">
                <span>
                  12,00 м
                  <sup>2</sup>
                </span>
              </div>
              <div class="f-full">
                <span>1 комната</span>
              </div>
              <div class="f-full">
                <span>2 этаж</span>
              </div>
              <div class="f-full">
                <span class="color-primary">Акция</span>
              </div>
              <div class="f-full">
                <span>
                  15 000 000 сум / м
                  <sup>2</sup>
                </span>
              </div>
              <div class="f-full">
                <div class="text-right">
                  <span class="line-through d-block color-primary mb-1">46 000 000 сум</span>
                  <span>46 000 000 сум</span>
                </div>
              </div>
            </div>

            <div class="form-table-items d-flex align-center text-white">
              <div class="f-full">
                <p class="color-primary">2-01</p>
              </div>
              <div class="f-full">
                <span>
                  12,00 м
                  <sup>2</sup>
                </span>
              </div>
              <div class="f-full">
                <span>1 комната</span>
              </div>
              <div class="f-full">
                <span>2 этаж</span>
              </div>
              <div class="f-full">
                <span class="color-primary">Акция</span>
              </div>
              <div class="f-full">
                <span>
                  15 000 000 сум / м
                  <sup>2</sup>
                </span>
              </div>
              <div class="f-full">
                <div class="text-right">
                  <span class="line-through d-block color-primary mb-1">46 000 000 сум</span>
                  <span>46 000 000 сум</span>
                </div>
              </div>
            </div>

            <div class="form-table-items d-flex align-center text-white">
              <div class="f-full">
                <p class="color-primary">2-01</p>
              </div>
              <div class="f-full">
                <span>
                  12,00 м
                  <sup>2</sup>
                </span>
              </div>
              <div class="f-full">
                <span>1 комната</span>
              </div>
              <div class="f-full">
                <span>2 этаж</span>
              </div>
              <div class="f-full">
                <span class="color-primary">Акция</span>
              </div>
              <div class="f-full">
                <span>
                  15 000 000 сум / м
                  <sup>2</sup>
                </span>
              </div>
              <div class="f-full">
                <div class="text-right">
                  <span class="line-through d-block color-primary mb-1">46 000 000 сум</span>
                  <span>46 000 000 сум</span>
                </div>
              </div>
            </div>

            <div class="form-table-items d-flex align-center text-white">
              <div class="f-full">
                <p class="color-primary">2-01</p>
              </div>
              <div class="f-full">
                <span>
                  12,00 м
                  <sup>2</sup>
                </span>
              </div>
              <div class="f-full">
                <span>1 комната</span>
              </div>
              <div class="f-full">
                <span>2 этаж</span>
              </div>
              <div class="f-full">
                <span class="color-primary">Акция</span>
              </div>
              <div class="f-full">
                <span>
                  15 000 000 сум / м
                  <sup>2</sup>
                </span>
              </div>
              <div class="f-full">
                <div class="text-right">
                  <span class="line-through d-block color-primary mb-1">46 000 000 сум</span>
                  <span>46 000 000 сум</span>
                </div>
              </div>
            </div>

            <div class="form-table-items d-flex align-center text-white">
              <div class="f-full">
                <p class="color-primary">2-01</p>
              </div>
              <div class="f-full">
                <span>
                  12,00 м
                  <sup>2</sup>
                </span>
              </div>
              <div class="f-full">
                <span>1 комната</span>
              </div>
              <div class="f-full">
                <span>2 этаж</span>
              </div>
              <div class="f-full">
                <span class="color-primary">Акция</span>
              </div>
              <div class="f-full">
                <span>
                  15 000 000 сум / м
                  <sup>2</sup>
                </span>
              </div>
              <div class="f-full">
                <div class="text-right">
                  <span class="line-through d-block color-primary mb-1">46 000 000 сум</span>
                  <span>46 000 000 сум</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <BottomNavigation />
  </div>
</template>

<script>
import BottomNavigation from "./components/BottomNavigation";
export default {
  data() {
    return {
      value: [0, 100],
      show: false
    };
  },
  components: {
    BottomNavigation
  },
  methods: {
    toggleDiscount() {
      event.target.closest(".select-form-discount").classList.toggle("active");
    }
  }
};
</script>

<style></style>
